import { ListItemButtonProps } from '@mui/material/ListItemButton';
import { NavigationItemVerticalPadding } from '@cbridge-tools/navigation-item';
import { FILTER_ITEM_PADDING_X, EXPAND_BUTTON_WIDTH, FILTER_ITEM_MAX_HEIGHT } from './FilterBlockItemBase.constant';

export const getListItemButtonStyle = (
  depth: number,
  hasNestedItems: boolean,
  isNullMarginLeft: boolean,
  depthPaddingMultiplier?: number,
): ListItemButtonProps['sx'] => {
  const paddingMultiplier = depthPaddingMultiplier ?? 1;
  let pl = paddingMultiplier * depth;

  if (isNullMarginLeft) {
    if (!hasNestedItems && depth > 0) {
      // Indent the leaf checkbox one level to the right of the parent group checkbox
      pl += EXPAND_BUTTON_WIDTH;
    }
  } else {
    pl = FILTER_ITEM_PADDING_X * (depth + 1) + (hasNestedItems
      ? 0
      : EXPAND_BUTTON_WIDTH);
  }

  return {
    pl,
    pr: FILTER_ITEM_PADDING_X,
    py: hasNestedItems ? NavigationItemVerticalPadding.sm : 1,
    maxHeight: FILTER_ITEM_MAX_HEIGHT,
    overflow: 'hidden',
  };
};
